import Immutable from 'immutable';
import { createSelector } from 'reselect';

// state selectors
export const allBlocksSelector = (state) => state.Blocks;
const allPagesSelector = (state) => state.Pages.get('byPath');

// Helper methods
export const getBlockById = (blocks, blockId) => blocks.get(`block-${blockId}`);

// selectors
export const getPageBlocks = createSelector(
  [allPagesSelector, allBlocksSelector],
  (allPages, allBlocks) => {
    return allPages.reduce((current, page) => {
      const blocks = page
        .get('blockIndexes', Immutable.List())
        .map((blockId) => getBlockById(allBlocks, blockId));
      return current.set(page.get('path'), blocks);
    }, Immutable.Map());
  }
);
